<template>
  <div class="page-container">
    <span class="parent-path">公司管理 / </span><span class="current-path">編輯公司</span>
    <span class="page-title">編輯公司</span>
    <div class="card-content">
      <a-form @submit.prevent="handleSubmit" class="company-form">
        <!-- 公司資訊 -->
        <div class="section">
          <h4>公司資訊</h4>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.name ? 'error' : ''" :help="errors.name">
              <a-label for="companyName">公司名稱</a-label>
              <a-input v-model:value="company.name" id="companyName" type="text" placeholder="請輸入公司名稱"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.tax_id ? 'error' : ''" :help="errors.tax_id">
              <a-label for="taxId">統一編號</a-label>
              <a-input v-model:value="company.tax_id" id="taxId" type="text" placeholder="請填寫統一編號"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.address ? 'error' : ''" :help="errors.address">
              <a-label for="address">地址</a-label>
              <a-input v-model:value="company.address" id="address" type="text" placeholder="請輸入地址"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.representative ? 'error' : ''" :help="errors.representative">
              <a-label for="representative">公司代表人</a-label>
              <a-input v-model:value="company.representative" id="representative" type="text"
                       placeholder="請填寫公司代表人"/>
            </a-form-item>
          </div>
        </div>
        <hr/>
        <!-- 公司管理人 -->
        <div class="section">
          <h4>管理人</h4>
          <div class="form-grid">
            <div class="form-group">
              <a-label for="lastName">姓氏</a-label>
              <a-input id="lastName" type="text" :value="owner?.last_name" readonly/>
            </div>
            <div class="form-group">
              <a-label for="firstName">名字</a-label>
              <a-input id="firstName" type="text" :value="owner?.first_name" readonly/>
            </div>
            <div class="form-group">
              <a-label for="email">電子信箱</a-label>
              <a-input id="email" type="email" :value="owner?.email" readonly/>
            </div>
            <div class="form-group">
              <a-label for="password">密碼</a-label>
              <a-input id="password" type="password" placeholder="（包含英文文字及數字，長度為6個字元以上）" readonly/>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <a-button type="button" class="btn-cancel" @click="handleCancel">取消</a-button>
          <a-button html-type="submit" class="btn-submit">儲存</a-button>
        </div>
      </a-form>
    </div>
  </div>
</template>

<script>
import {message} from "ant-design-vue";

export default {
  data() {
    return {
      company: {},
      owner: {},
      errors: {
        name: "",
        tax_id: "",
        address: "",
        representative: "",
      }
    };
  },
  mounted() {

    const token = localStorage.getItem('token');
    this.$axios.get(`/api/organizations/${this.$route.params.id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      console.log(response.data.data)
      this.company = response.data.data
      this.owner = this.company.users.filter((item) => item.role === "admin")[0]
    }).catch(error => {
      console.error(error);
      if (error.status === 401) {
        this.$router.push('/login');
      }
    });
  },
  methods: {
    handleSubmit() {
      console.log("表單提交", this.company);

      for (let key in this.errors) {
        this.errors[key] = ""
      }

      const token = localStorage.getItem('token');
      this.$axios.patch(`/api/organizations/${this.$route.params.id}`, {
        name: this.company.name,
        address: this.company.address,
        tax_id: this.company.tax_id,
        representative: this.company.representative
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response)
        message.success('已完成公司編輯');
      }).catch(error => {
        console.error(error);
        if (error.status === 401) {
          this.$router.push('/login');
        } else {
          console.log(error.response.data);
          let errors = error.response.data
          for (let key in errors) {
            this.errors[key] = errors[key]['message']
          }
        }
      });
    },
    handleCancel() {
      console.log("取消操作");
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  width: 1024px;
  padding: 20px;
  margin-top: 16px;
}

h1 {
  font-size: 1.5em;
  margin-bottom: 1em;
}

.section {
  margin-bottom: 2em;
}

.section h2 {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 0.9em;
  margin-bottom: 0.5em;
  color: #333;
}

input {
  padding: 0.7em;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input[readonly] {
  background-color: #e0e0e0;
  border: solid 1px #999999;
}

input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
}

.btn-cancel {
  background-color: #f8f9fa;
  color: #333;
}

.btn-submit {
  background-color: #007bff;
  color: white;
}

.btn-submit:hover {
  background-color: #0056b3;
}
</style>
